<template>
    <div>
        <b-card no-body v-if="perfilGestor">
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span
                        >PRAZOS PARA SOLICITAÇÕES DE ADITIVOS DAS
                        CONTRATAÇÕES</span
                    >
                </h5>
                <pnl-vencimentos-contratacoes
                    :pnlVencimentos="pnlVencimentos"
                    v-if="perfilGestor"
                    @filtrar="$emit('filtrar', $event)"
                >
                </pnl-vencimentos-contratacoes>
            </b-card-body>
        </b-card>
        <b-card no-body>
            <b-card-header>
                <span class="h5">CONTRATAÇÕES</span>
            </b-card-header>
            <b-card-body>
                <slot name="filtros"></slot>
                <app-tabela
                    idTabela="tblContratacoes"
                    :itens="contratacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :rowClass="rowClass"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valorHora" slot-scope="data">
                        <p class="text-right m-0 p-0">
                            {{ data.valorHora | currency }}
                        </p>
                    </template>
                    <template slot="valorTotal" slot-scope="data">
                        <p class="text-right m-0 p-0">
                            {{ data.valorTotal | currency }}
                        </p>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PnlVencimentosContratacoes from './PnlVencimentosContratacoes'

export default {
    props: {
        contratacoes: {
            type: Array,
            default: () => []
        },

        pnlVencimentos: {
            type: Object
        },

        rowClass: {
            type: Function,
            default: () => ({})
        }
    },

    components: {
        PnlVencimentosContratacoes
    },

    computed: {
        perfilGestor() {
            return (
                this.$route.name == 'Gestores_Contratacoes' ||
                this.$route.name == 'Gestores_Contratacoes_Detalhar' ||
                this.$route.name == 'Gestores_Entregas_Detalhar2'
            )
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'codContratacao',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'gestor',
                    label: 'Gestor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'objeto',
                    label: 'Objeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataInicio',
                    label: 'Início',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataFim',
                    label: 'Fim',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'qtdEntregas',
                    label: 'Entregas',
                    tdClass: 'text-center'
                },
                {
                    key: 'situacaoDescr',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    }
}
</script>
